import { cartStore } from '../cart/cart';
import { paymentStore } from '../payment/payment';

export default {
    async setCouponCode(data) {
        const storeCart = cartStore()
        const storePayment = paymentStore()

        if (!data || !data?.coupon) {
            this.setCouponToStorage('')
        }


        if (data.page === 'cart') {
            const res = await storeCart.setCartListing({ coupon: data.coupon })
 
            const coupon = res.data?.coupon 
            
            if(coupon && coupon?.success){
                this.setCouponToStorage(data.coupon)
            }
           
        }

        else {
            const res = await storePayment.setCartData({ coupon: data.coupon })
            const coupon = res.data?.coupon 
            
            if(coupon && coupon?.success){
                this.setCouponToStorage(data.coupon)
            }

        }
      
    },

    setCouponToStorage(coupon) {
        return this.commitMutation('setCouponToStorage', coupon)
    },


}